import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const WhatsappButton = () => {
    return (
        <a href="https://wa.me/237698250070" className="whatsapp-link">
            <div className="whatsapp-body">
                <FontAwesomeIcon icon={faWhatsapp} className="whatsapp-logo" />
            </div>
        </a>
    )
}